import React from 'react';

import { Knob, Arc, Pointer } from '../../packages/rc-knob';

const KnobField = ({
                       size = 'md',
                       className = '',
                       name = '',
                       min = 0,
                       max = 100,
                       value = 0,
                       changeFn = () => {
                       }
                   }) => {
    const combinedClassName = `fieldKnob ${className}`;

    // Size configurations
    const sizeConfig = {
        sm: {
            knobSize: 50,
            svgWidth: 46,
            svgHeight: 48,
            viewWidth: 108,
            viewHeight: 108,
            translateX: 3,
            translateY: 2,
            scale: 1,
            pointerRadius: 10
        },
        md: {
            knobSize: 108,
            svgWidth: 100,
            svgHeight: 103,
            viewWidth: 106,
            viewHeight: 108,
            translateX: 5,
            translateY: 4,
            scale: 1,
            pointerRadius: 33
        },
        lg: {
            knobSize: 150,
            svgWidth: 139,
            svgHeight: 143,
            viewWidth: 136,
            viewHeight: 140,
            translateX: 5,
            translateY: 5,
            scale: 1.32,
            pointerRadius: 48
        }
    };

    const config = sizeConfig[size] ? sizeConfig[size] : sizeConfig['md'];

    return (
        <Knob
            size={config.knobSize}
            angleOffset={220}
            angleRange={280}
            min={min}
            max={max}
            value={Number(value) || 0}
            className={combinedClassName}
            onChange={value => changeFn(value, name)}
        >
            <Arc
                className="arc"
                arcWidth={4.1}
                background="var(--color)"
                color="var(--color-7)"
            />
            <svg
                width={config.svgWidth}
                height={config.svgHeight}
                viewBox={`0 0 ${config.viewWidth} ${config.viewHeight}`}
                fill="none"
                style={{
                    transform: `translate(${config.translateX}px, ${config.translateY}px) scale(${config.scale})`,
                    filter: 'url(#customSvgShadow)'
                }}
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_ii_5585_21913)">
                    <circle cx="52" cy="52" r="52" fill="url(#paint0_linear_5585_21913)"/>
                </g>
                <g filter="url(#filter1_ii_5585_21913)">
                    <circle cx="46" cy="46" r="46" transform="matrix(1 0 0 -1 6 98)"
                            fill="url(#paint1_linear_5585_21913)"/>
                </g>
                <defs>
                    <filter id="customSvgShadow" x="-20%" y="-10%" width="140%" height="140%">
                        <feDropShadow dx="0" dy="7" stdDeviation="7" floodColor="rgba(0,0,0,0.8)"/>
                    </filter>

                    <filter id="filter0_ii_5585_21913" x="0" y="-0.82036" width="104" height="105.641"
                            filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="-0.82036"/>
                        <feGaussianBlur stdDeviation="1.23054"/>
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.122034 0 0 0 0 0.146441 0 0 0 0 0.18 0 0 0 1 0"/>
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5585_21913"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="0.82036"/>
                        <feGaussianBlur stdDeviation="0.41018"/>
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.2788 0 0 0 0 0.338933 0 0 0 0 0.41 0 0 0 1 0"/>
                        <feBlend mode="normal" in2="effect1_innerShadow_5585_21913"
                                 result="effect2_innerShadow_5585_21913"/>
                    </filter>
                    <filter id="filter1_ii_5585_21913" x="6" y="5" width="92" height="94" filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="-1"/>
                        <feGaussianBlur stdDeviation="1"/>
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.221867 0 0 0 0 0.260267 0 0 0 0 0.32 0 0 0 1 0"/>
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_5585_21913"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                       result="hardAlpha"/>
                        <feOffset dy="1"/>
                        <feGaussianBlur stdDeviation="1.5"/>
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.1564 0 0 0 0 0.190133 0 0 0 0 0.23 0 0 0 1 0"/>
                        <feBlend mode="normal" in2="effect1_innerShadow_5585_21913"
                                 result="effect2_innerShadow_5585_21913"/>
                    </filter>
                    <linearGradient id="paint0_linear_5585_21913" x1="47.6667" y1="6.45717e-07" x2="47.6667"
                                    y2="101.111" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#394252"/>
                        <stop offset="1" stopColor="#28303B"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_5585_21913" x1="42.1667" y1="5.71211e-07" x2="42.1667"
                                    y2="89.4444" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#394252"/>
                        <stop offset="1" stopColor="#28303B"/>
                    </linearGradient>
                </defs>
            </svg>
            <Pointer
                width={2.7}
                radius={config.pointerRadius}
                type="circle"
                color="var(--color-7)"
            />
        </Knob>
    );
};

export default KnobField;